export default "__VITE_ASSET__2bd53476__"